@if (show) {
<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <fa-icon [icon]="faUpload"></fa-icon>
        {{ 'ARCHIVES.UPLOAD_MODAL.TITLE' | translate }}
      </h3>
      <button class="close-btn" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="tag-picker-section">
        <div class="tag-picker-row">
          <span class="tag-picker-label">
            <fa-icon [icon]="faTag"></fa-icon>
            {{ 'ARCHIVES.UPLOAD_MODAL.TAGS_LABEL' | translate }}
          </span>
          <div class="selected-tags">
            @for (tag of selectedTags; track tag.id) {
            <span class="tag-chip" [style.background-color]="tag.bg_color" [style.color]="tag.text_color">
              {{ tag.name }}
              <button type="button" class="tag-chip-remove" (click)="removeTag(tag)">
                <fa-icon [icon]="faTimes"></fa-icon>
              </button>
            </span>
            }
            @if (selectedTags.length < MAX_TAGS) {
            <button type="button" class="add-tag-btn" [class.active]="showTagDropdown" (click)="toggleTagDropdown()"
              [disabled]="uploadLoading">
              <fa-icon [icon]="faPlus"></fa-icon>
              {{ 'ARCHIVES.UPLOAD_MODAL.ADD_TAG' | translate }}
            </button>
            }
          </div>
        </div>

        @if (showTagDropdown) {
        <div class="tag-dropdown-panel">
          <div class="tag-search">
            <fa-icon [icon]="faSearch" class="tag-search-icon"></fa-icon>
            <input type="text" [(ngModel)]="tagSearchTerm" (input)="filterTags()"
              [placeholder]="'MODAL.LINK.TAG.SEARCH_PLACEHOLDER' | translate" />
          </div>
          <div class="tag-options">
            @for (tag of filteredAvailableTags; track tag.id) {
            <button type="button" class="tag-option" (click)="selectTag(tag)" [disabled]="isTagSelected(tag)">
              <span class="tag-badge" [style.background-color]="tag.bg_color" [style.color]="tag.text_color">
                {{ tag.name }}
              </span>
              @if (isTagSelected(tag)) {
              <fa-icon [icon]="faCheck" class="tag-option-check"></fa-icon>
              }
            </button>
            }
            @if (filteredAvailableTags.length === 0) {
            <div class="tag-options-empty">{{ 'MODAL.LINK.TAG.NO_TAGS' | translate }}</div>
            }
          </div>
        </div>
        }
      </div>

      <div class="upload-actions">
        <button class="action-btn" (click)="triggerFileInput()" [disabled]="uploadLoading">
          <fa-icon [icon]="faFile"></fa-icon>
          {{ 'ARCHIVES.UPLOAD_MODAL.FILE' | translate }}
        </button>
        <button class="action-btn" (click)="triggerFolderInput()" [disabled]="uploadLoading">
          <fa-icon [icon]="faUpload"></fa-icon>
          {{ 'ARCHIVES.UPLOAD_MODAL.FOLDER' | translate }}
        </button>
        <button class="action-btn remove-all" (click)="clearSelectedFiles()" [disabled]="selectedFiles.length === 0">
          <fa-icon [icon]="faTimes"></fa-icon>
          {{ 'ARCHIVES.UPLOAD_MODAL.REMOVE_ALL' | translate }}
        </button>
      </div>

      <div class="selected-files-list">
        @if (selectedFiles.length === 0) {
        <div class="empty-state">
          <p>{{ 'ARCHIVES.UPLOAD_MODAL.NO_FILES' | translate }}</p>
        </div>
        }
        @for (file of selectedFiles; track file; let i = $index) {
        <div class="file-item">
          <div class="file-info">
            <fa-icon [icon]="faFile"></fa-icon>
            <span>{{ file.name }}</span>
          </div>
          <button class="remove-btn" (click)="removeFile(i)">
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
        </div>
        }
      </div>

      <input #fileInput type="file" style="display:none" multiple (change)="onFileSelected($event)" />
      <input #folderInput type="file" style="display:none" webkitdirectory directory multiple
        (change)="onFolderSelected($event)" />
    </div>
    <div class="modal-footer">
      <div class="selection-count">
        {{ selectedFiles.length}} {{ 'ARCHIVES.SELECTED' | translate }}
      </div>
      <div class="form-actions">
        <button class="cancel-button" (click)="onClose()" [disabled]="uploadLoading">
          {{ 'BUTTON.CANCEL' | translate }}
        </button>
        <button class="save-button" (click)="confirmUpload()" [disabled]="selectedFiles.length === 0 || uploadLoading">
          <fa-icon [icon]="faCheck"></fa-icon>
          {{ 'BUTTON.UPLOAD' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
}